import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    Dropzone.options.myAwesomeDropzone = {
      init: function() {
        this.on("queuecomplete", function(file) { alert("Added file."); });
      }
    };
    var myDropzone = new Dropzone("div#car-images", { 
      url: '/admin/images',
      acceptedFiles: "image/png,image/gif,image/jpg,image/jpeg,image/pjpeg,image/tiff,image/bmp,image/vnd.adobe.photoshop,image/vnd.microsoft.icon,image/webp",
      headers: { "Accept": "text/html" },
      success: function(file, response) {
        document.getElementById('bulk-images').innerHTML =response;
      }
    });
  }
}